import { LAYOUT } from '@/router/constant'
import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from './basic'
import { menuRoutes } from './async'
// import { otherRoutes } from './other'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@views/Login/Login.vue'),
    meta: {},
  },
  {
    path: '/',
    name: 'Root',
    component: LAYOUT,
    meta: {
      name: 'Root',
    },
    children: [],
  },
]

export const basicRoutes = [...routes, REDIRECT_ROUTE]
export const asyncRoutes = [...menuRoutes, PAGE_NOT_FOUND_ROUTE]

export default {}
